var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalAlertIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 79.999,
    viewBox: "0 0 80.05 79.999",
    width: 80.05,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff8200",
    transform: "translate(-1974.325 -212.645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2049.655 292.644h-70.608a4.719 4.719 0 0 1 -4.261-6.747l35.318-70.589a4.718 4.718 0 0 1 8.508.029l35.288 70.513a4.72 4.72 0 0 1 -4.24 6.794zm-69.608-5.337h68.609l-34.305-68.56zm33.768-69.63.006.011z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2011.683 239.275h5.338v32.021h-5.338z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2011.683 276.633h5.338v5.337h-5.338z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalAlertIcon);
export default __webpack_public_path__ + "static/media/modal-alert-icon.8fea8b4d.svg";
export { ForwardRef as ReactComponent };